function submitPreview($eventForm) {
    var modal = $('<div data-reveal>').addClass('reveal-modal')
                                    .appendTo('body');
    var formData = $eventForm.serializeArray();
    $.ajax({
        url: $eventForm.attr('action'),
        type: 'post',
        data: formData,
        success: function(data) {
            modal.empty().html($(data).find('#main'))
                .append('<a class="close-reveal-modal">&#215;</a>')
                .foundation('reveal', 'open', {animation: 'fade'});

            modal.find('#preview-accepted').click(function() {
                $eventForm.find('#event-create').click();
            });

            $(document).trigger('overlay:loaded');
        }
    });
}

function previewEvent($eventForm, $previewButton) {
    $previewButton.click(function() {
        var valid = $eventForm.parsley().validate();
        if (!valid) {
            return;
        }
        grecaptcha.ready(function() {
            grecaptcha.execute(globals.recaptcha_site_key, {action: 'submit'}).then(function(token) {
                const response = document.getElementsByName("g-recaptcha-response");
                const form = document.getElementById("create-event-form");
                form.appendChild(response[0]);
                submitPreview($eventForm);
            });
        });
    });
}

export default previewEvent;



// WEBPACK FOOTER //
// ./src/js/app/components/preview.js